import React, { useEffect, useState } from "react"
import moment from "moment"
import { FormattedMessage } from "react-intl"
import LoginSelector from "./LoginSelector/LoginSelector"
import "./LoginLanding.scss"
import ForbiddenModal from "../Shared/Modals/Forbidden"

export const UNAUTHORIZED_MESSAGE_CODE: string = "unauthorized"

interface LoginLandingProps {}

const LoginLanding: React.FC<LoginLandingProps> = () => {
	const className = "login-landing"
	const [forbiddenModalOpen, setForbiddenModalOpen] = useState<boolean>(false)

	useEffect(() => {
		const urlSearchParams = new URLSearchParams(location.search)
		const contentMessageAlert = urlSearchParams.get("message")
		if (contentMessageAlert === UNAUTHORIZED_MESSAGE_CODE) {
			setForbiddenModalOpen(true)
		}
	}, [])

	return (
		<React.Fragment>
			<div data-testid="login-container" className={`${className}-container`}>
				<ForbiddenModal
					isOpen={forbiddenModalOpen}
					onClose={() => {
						setForbiddenModalOpen(false)
					}}
				/>
				<div className={`${className}-login-body`}>
					<LoginSelector />
				</div>
			</div>
			<div className={`${className}-copyright`}>
				<FormattedMessage
					id="phronesis.footer.copyright"
					values={{ year: moment().format("YYYY") }}
				/>
			</div>
		</React.Fragment>
	)
}

export default LoginLanding
